import React from 'react';
import '@ui5/webcomponents-fiori/dist/illustrations/UnableToLoad';
import { IllustratedMessage } from '@ui5/webcomponents-react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './UnableLoadUserInfoPage.jss';

import IllustrationMessageType from '@ui5/webcomponents-fiori/dist/types/IllustrationMessageType.js';

export const UnableLoadUserInfoPage: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <IllustratedMessage
      name={IllustrationMessageType.UnableToLoad}
      data-help-id="no-permission-illustration"
      data-testid="no-permission-illustration"
      titleText={t('unable-load-supplier-title')}
      subtitleText={t('unable-load-supplier-subtitle')}
      className={classes.illustratedMessage}
    />
  );
};
